import { createI18n } from 'vue-i18n';
import { useLocale, globalLocale, type Locale } from '@/shared/lib/i18n';
import ja from '../locales/ja';
import en from '../locales/en';

const i18n = createI18n({
    legacy: false,
    locale: 'en' as Locale,
    fallbackLocale: 'ja' as Locale,
    messages: { ja, en },
    warnHtmlMessage: false,
});

// sharedレイヤーのglobalLocaleを使用（FSD準拠）
export const useApplicationLocale = () => useLocale<typeof ja>(i18n, globalLocale);
